module.exports = __webpack_public_path__ + "img/pic-02.38db9c8f.png";